import React, { useContext, useEffect } from 'react';
import { Container, Typography } from '@mui/material';
import Header from '../components/layout/Header';
import EventsSection from '../components/sections/EventsSection';
import { Context } from '../App';

const Billetterie = () => {

  return (
    <>
      <Header />
      <Container maxWidth="xl" sx={{ mt: 4, px: { xs: 2, sm: 3 } }}>
        <Typography variant="h2" component="h1" gutterBottom sx={{ fontSize: { xs: '1.75rem', sm: '2.5rem' } }}>Billetterie</Typography>
        <EventsSection />
      </Container>
    </>
  );
};

export default Billetterie;